'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContactRest = function () {
  function ContactRest($http) {
    (0, _classCallCheck3.default)(this, ContactRest);

    this.$http = $http;
    this.sprintf = require("sprintf-js").sprintf;

    this.PATH = {
      LIST: 'contacts/',
      DETAIL: 'contacts/%1$s/'
    };
  }

  (0, _createClass3.default)(ContactRest, [{
    key: 'getList',
    value: function getList(params) {
      return this.$http.get(this.PATH.LIST, { params: params });
    }
  }, {
    key: 'getContact',
    value: function getContact(id) {
      return this.$http.get(this.sprintf(this.PATH.DETAIL, id));
    }
  }]);
  return ContactRest;
}();

exports.default = ContactRest;


//////////////////
// WEBPACK FOOTER
// ./src/api/ContactResource.js
// module id = 306
// module chunks = 0